import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/storageManagement';
import { IActivityFilesListByTermSetAction } from '../../models/pages/addedActivityFiles';
import { ActivityAddedFileTabNumbers } from '../../models/enums/StorageManagement';

let tabName: string;

const storageManagementReducer = (state = GlobalState().storageManagement, action: Types.IAction) => {
    if (!state) {
        return state;
    }

    const newState: any = { ...state };

    if (action.type === Actions.actions.GET_GENERAL_STATISTICS) {
    } else if (action.type === Actions.actions.SET_GENERAL_STATISTICS) {
        const storageManagementPageActionPayload = action as any;
        const storageManagementPage = storageManagementPageActionPayload.storageManagementPage ? storageManagementPageActionPayload.storageManagementPage : [];
        newState.storageManagementPage = storageManagementPage;
    } else if (action.type === Actions.actions.GET_FILES_ADDED_ACTIVITIES_STATISTICS) {
    } else if (action.type === Actions.actions.SET_FILES_ADDED_ACTIVITIES_STATISTICS) {
        const filesAddedActivitiesTermListPageActionPayload = action as any;
        const filesAddedActivitiesTermListPage = filesAddedActivitiesTermListPageActionPayload.filesAddedActivities ? filesAddedActivitiesTermListPageActionPayload.filesAddedActivities : [];
        newState.filesAddedActivitiesTermListPage = filesAddedActivitiesTermListPage;
    } else if (action.type === Actions.actions.GET_ACTIVITY_FILES_STATISTICS_BYTERM) {
    } else if (action.type === Actions.actions.SET_ACTIVITY_FILES_STATISTICS_BYTERM) {
        const filesActivityFilesStatisticsByTermActionPayload = action as any;
        const activityFilesStatisticsByTerm = filesActivityFilesStatisticsByTermActionPayload.activityFilesStatisticsByTerm ? filesActivityFilesStatisticsByTermActionPayload.activityFilesStatisticsByTerm : [];
        newState.activityFilesStatisticsByTerm = activityFilesStatisticsByTerm;
    } else if (action.type === Actions.actions.GET_ACTIVITY_FILES_LIST_BYTERM) {
        const filesActivityFilesListByTermActionPayload = action as any;
        tabName = filesActivityFilesListByTermActionPayload.filters.tabName;
    } else if (action.type === Actions.actions.SET_ACTIVITY_FILES_LIST_BYTERM) {
        const filesActivityFilesListByTermActionPayload = action as any;
        if (tabName == ActivityAddedFileTabNumbers.activity_files) {
            const filesActivityFilesListByTermActionData = {
                results: filesActivityFilesListByTermActionPayload.activityFilesListByTerm.results,
                filters: filesActivityFilesListByTermActionPayload.activityFilesListByTerm.filters
            };
            newState.activityFilesListByTerm = filesActivityFilesListByTermActionData;
        } else if (tabName == ActivityAddedFileTabNumbers.assignment_files) {
            const filesAssignmentFilesListByTermActionData = {
                results: filesActivityFilesListByTermActionPayload.activityFilesListByTerm.results,
                filters: filesActivityFilesListByTermActionPayload.activityFilesListByTerm.filters
            };
            newState.assignmentFilesListByTerm = filesAssignmentFilesListByTermActionData;
        } else if (tabName == ActivityAddedFileTabNumbers.deleted_files) {
            const filesDeletedFilesListByTermActionData = {
                results: filesActivityFilesListByTermActionPayload.activityFilesListByTerm.results,
                filters: filesActivityFilesListByTermActionPayload.activityFilesListByTerm.filters
            };
            newState.deletedFilesListByTerm = filesDeletedFilesListByTermActionData;
        }
    } else if (action.type === Actions.actions.GET_COMMUNICATION_FILES_LIST) {
    } else if (action.type === Actions.actions.SET_COMMUNICATION_FILES_LIST) {
        const filesCommunicationFilesListActionPayload = action as any;
        const filesCommunicationFilesListActionPayloadData = {
            results: filesCommunicationFilesListActionPayload.communicationFilesList.results,
            filters: filesCommunicationFilesListActionPayload.communicationFilesList.filters
        };
        newState.communicationFilesList = filesCommunicationFilesListActionPayloadData;
    } else if (action.type === Actions.actions.GET_COMMUNICATION_FILES_STATISTICS) {
    } else if (action.type === Actions.actions.SET_COMMUNICATION_FILES_STATISTICS) {
        const filesCommunicationStatisticsActionPayload = action as any;
        const communicationFilesStatistics = filesCommunicationStatisticsActionPayload.communicationFilesStatistics ? filesCommunicationStatisticsActionPayload.communicationFilesStatistics : [];
        newState.communicationFilesStatistics = communicationFilesStatistics;
    } else if (action.type === Actions.actions.GET_PERSONEL_FILES_LIST) {
    } else if (action.type === Actions.actions.SET_PERSONEL_FILES_LIST) {
        const filesPersonelFilesListActionPayload = action as any;
        const filesPersonelFilesListActionPayloadData = {
            results: filesPersonelFilesListActionPayload.personelFilesList.results,
            filters: filesPersonelFilesListActionPayload.personelFilesList.filters
        };
        newState.personelFilesList = filesPersonelFilesListActionPayloadData;
    } else if (action.type === Actions.actions.GET_OTHER_FILES_LIST) {
    } else if (action.type === Actions.actions.SET_OTHER_FILES_LIST) {
        const filesOtherFilesListActionPayload = action as any;
        const filesOtherFilesListActionPayloadData = {
            results: filesOtherFilesListActionPayload.otherFilesList.results,
            filters: filesOtherFilesListActionPayload.otherFilesList.filters
        };
        newState.otherFilesList = filesOtherFilesListActionPayloadData;
    }
    return Object.assign({}, state, newState);
};

export default storageManagementReducer;
